import React from 'react';
import { ConfigProvider } from 'antd';
import type { Locale } from 'antd/es/locale';
import ptPT from 'antd/locale/pt_PT';
import enUS from 'antd/locale/en_US';
import { useTranslation } from 'react-i18next';

const ptLocale: Locale = {
  ...ptPT,
  Pagination: {
    ...ptPT.Pagination,
    items_per_page: '/ página',
    page_size: 'dimensão da página',
  },
};

interface LocaleProviderProps {
  children: React.ReactNode;
}

const LocaleProvider: React.FC<LocaleProviderProps> = ({ children }) => {
  const { i18n } = useTranslation();
  const locale = i18n.language?.startsWith('en') ? enUS : ptLocale;

  return <ConfigProvider locale={locale}>{children}</ConfigProvider>;
};

export default LocaleProvider;
